import { render } from "./form.vue?vue&type=template&id=3ef5c2ca"
import script from "./form.vue?vue&type=script&setup=true&lang=js"
export * from "./form.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/linker-marketplace-web/linker-marketplace-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/v2/components/form/form.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3ef5c2ca"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3ef5c2ca', __exports__)) {
    console.log('reload')
    api.reload('3ef5c2ca', __exports__)
  }
  
  module.hot.accept("./form.vue?vue&type=template&id=3ef5c2ca", () => {
    console.log('re-render')
    api.rerender('3ef5c2ca', render)
  })

}


export default __exports__